/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import { ActionButton, Link, MessageBar, MessageBarType } from "@fluentui/react";
import Header from "./Header";
import Progress from "./Progress";
import { signIn, signOut } from "../../auth/signin";
import CharacterBox from "./CharacterBox";
import styled from "styled-components";
import jwt_decode from "jwt-decode";
import { FaqList } from "./FaqList";
import { EveLogo } from "./EveLogo";
import { CommandsList } from "./CommandsList";
import { Divider, Text, Button } from "@fluentui/react-components";
import { Link32Regular } from "@fluentui/react-icons";
import PubSub from "pubsub-js";

export interface AppProps {
  title: string;
  isOfficeInitialized: boolean;
}
export interface CharacterInfo {
  expiresOn?: string;
  characterName?: string;
  characterId?: number;
}
export interface Token {
  exp: string;
  name: string;
  sub: string;
}
export interface AppState {
  authStatus?: string;
  errorMessage?: string;
  characterList: CharacterInfo[];
  notsupported: boolean;
  apiError: string;
  apiErrorShow: boolean;
}

const CharacterWrap = styled.div`
  margin-top: 5px;
`;

const CenteredDiv = styled.div`
  margin: 0 auto;
  display: block;
  width: fit-content;
  .red {
    color: #bf2222;
    font-family: "ShentoxRegular";
    font-size: 16px;
    line-height: 1.3em;
    padding: 5px;
  }
  .redbold {
    color: #bf2222;
    font-weight: 500;
    font-family: "ShentoxMedium";
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 5px;
  }
`;

const ButtonWrap = styled.div`
  display: flex;
  flex-direction: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  width: fit-content;
`;

const ClickableDiv = styled.div`
  cursor: pointer;
  &:hover .CharacterName {
    text-decoration: underline;
  }
`;

const Version = styled.span`
  position: absolute;
  top: 0;
  left: 3px;
  font-size: 11px;
`;

const ThemeButton = styled.div`
  position: absolute;
  top: 22px;
  left: 2px;
  div {
    background-image: url("/$web/app/assets/sun.png");
    height: 15px;
    background-size: contain;
    background-repeat: no-repeat;
    width: 15px;
    pointer: cursor;
    border: 1px solid black;
    padding: 5px;
    border-radius: 5px;
    transition: 0.3s ease;
    &:hover {
      background-color: #efefef;
    }
  }
`;

const LoginButton = styled.div`
  padding: 5px;
  background: #d5d5d5;
  border: 1px groove #a8a8a8;
  height: 18px;
  min-width: 100px;
  border-radius: 3px;
  font-family: "ShentoxMedium";
  font-weight: bold;
  display: flex;
  align-items: center;
  color: #000 !important;
  position: relative;
  svg {
    margin-right: 11px;
    height: 9px;
    width: auto;
  }
  span {
    line-height: 1;
  }
  &:hover {
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
  }
  &:before {
    content: " ";
    width: 1px;
    height: 15px;
    background: #665e5e;
    position: absolute;
    left: 40px;
    top: -1px;
  }
`;
export default class App extends React.Component<AppProps, AppState> {
  constructor(props: any, context: any) {
    super(props, context);
    this.state = {
      authStatus: "notLoggedIn",
      errorMessage: "",
      characterList: [],
      notsupported: false,
      apiError: "",
      apiErrorShow: false,
    };

    // Bind the methods that we want to pass to, and call in, a separate
    // module to this component. And rename setState to boundSetState
    // so code that passes boundSetState is more self-documenting.
    //this.boundSetState = this.setState.bind(this);
    this.setTokenAndCharacter = this.setTokenAndCharacter.bind(this);
    this.clearTokenAndCharacter = this.clearTokenAndCharacter.bind(this);
    this.displayError = this.displayError.bind(this);
    this.login = this.login.bind(this);
    this.clearSingleTokenAndCharacter = this.clearSingleTokenAndCharacter.bind(this);
  }
  //boundSetState: () => {};

  setTokenAndCharacter = async (accesstoken: string, refreshtoken: string) => {
    const character = jwt_decode<Token>(accesstoken);
    const characterID = parseInt(character.sub.split(":")[2]);
    let characterArray: CharacterInfo[] = this.state.characterList;
    let exists = false;
    characterArray.forEach((item: CharacterInfo) => {
      if (item.characterId == characterID) {
        exists = true;
        item.expiresOn = character.exp;
      }
    });
    if (!exists) {
      const newChar = {
        characterName: character.name,
        characterId: characterID,
        expiresOn: character.exp,
      };
      characterArray.push(newChar);
    }
    this.setState({ characterList: characterArray });
    const charListLocalStorage = window.localStorage.getItem("characterList");
    if (charListLocalStorage === null) {
      window.localStorage.setItem("characterList", characterID.toString());
    } else if (charListLocalStorage !== null && charListLocalStorage?.indexOf(characterID.toString()) < 0) {
      const newList = charListLocalStorage + "," + characterID;
      window.localStorage.setItem("characterList", newList);
    }
    window.localStorage.setItem(`accesstoken-${characterID}`, accesstoken);
    window.localStorage.setItem(`refreshtoken-${characterID}`, refreshtoken);
    this.setState({ authStatus: "loggedIn" });
    this.errorDismissed();
  };

  //When the user hits the logout button
  clearSingleTokenAndCharacter = (id: number) => {
    window.localStorage.removeItem(`accesstoken-${id}`);
    window.localStorage.removeItem(`refreshtoken-${id}`);
    let characterArray: CharacterInfo[] = this.state.characterList;
    let newCharacterArray: CharacterInfo[] = [];
    characterArray.forEach((item: CharacterInfo) => {
      if (item.characterId !== id) {
        newCharacterArray.push(item);
      }
    });
    if (!newCharacterArray.length) {
      this.setState({ authStatus: "notLoggedIn" });
    }
    this.setState({ characterList: newCharacterArray });
    const localCharacterList = window.localStorage.getItem("characterList");
    if (localCharacterList) {
      const split = localCharacterList.split(",");
      const newCharacterList: string[] = [];
      split.forEach((item) => {
        if (parseInt(item) !== id) newCharacterList.push(item);
      });
      const rawList: string = newCharacterList.toString();
      if (rawList.length) {
        window.localStorage.setItem("characterList", rawList);
      } else window.localStorage.removeItem("characterList");
    }
  };
  clearTokenAndCharacter = (_status: string) => {
    this.setState({ authStatus: "notLoggedIn" });
    this.setState({ characterList: [] });
    //multicharacterLogin
    const characterList = window.localStorage.getItem("characterList");
    if (characterList) {
      const split = characterList.split(",");
      split.forEach((item) => {
        window.localStorage.removeItem(`accesstoken-${item}`);
        window.localStorage.removeItem(`refreshtoken-${item}`);
      });
      window.localStorage.removeItem("characterList");
    }
    this.errorDismissed();
  };

  displayError = (error: string) => {
    this.setState({ errorMessage: error });
  };

  // Runs when the user clicks the X to close the message bar where
  // the error appears.
  errorDismissed = () => {
    this.setState({ errorMessage: "" });
    // If the error occured during a "in process" phase (logging in),
    // the action didn't complete, so return the UI to the preceding state/view.
    this.setState((prevState) => {
      if (prevState.authStatus === "loginInProcess") {
        return { authStatus: "notLoggedIn" };
      }
      return null;
    });
  };
  errorMessageDismissed = () => {
    this.setState({ apiError: "" });
    this.setState({ apiErrorShow: false });
  };

  toggleTheme = async () => {
    (document.querySelector("body") as HTMLBodyElement).classList.toggle("darkmode");
    const current = window.localStorage.getItem("darkmode");
    if (current !== null && current == "false") window.localStorage.setItem(`darkmode`, "true");
    if (current !== null && current == "true") window.localStorage.setItem(`darkmode`, "false");
    if (current === null) window.localStorage.setItem(`darkmode`, "true");
  };

  login = async () => {
    await signIn(this.setTokenAndCharacter, this.displayError);
  };

  logout = async () => {
    await signOut(this.clearTokenAndCharacter, this.displayError);
  };

  componentDidMount() {
    const mySubscriber = (msg: any, data: any) => {
      switch (msg) {
        case "ERROR":
          console.log(data);
          if (data.indexOf("tweetfleet") > -1) {
            const function_name = data.split("(");
            let extra = "";
            if (function_name.length) {
              extra = function_name[function_name.length - 1];
            }
            data = "Error limit / Timeout.(" + extra;
          }
          this.setState({ apiError: data });
          this.setState({ apiErrorShow: true });
          break;
        default:
          break;
      }
    };
    PubSub.subscribe("ERROR", mySubscriber);
    const current = window.localStorage.getItem("darkmode");
    if (current !== null && current == "true")
      (document.querySelector("body") as HTMLBodyElement).classList.toggle("darkmode");
    const characterList = window.localStorage.getItem("characterList");
    if (characterList) {
      var splitList = characterList.split(",");
      let characterArray: CharacterInfo[] = this.state.characterList;
      splitList.forEach((item) => {
        const thisToken = window.localStorage.getItem(`accesstoken-${item}`);
        const refToken = window.localStorage.getItem(`refreshtoken-${item}`);
        if (thisToken && refToken) {
          const character = jwt_decode<Token>(thisToken);
          const characterID = parseInt(character.sub.split(":")[2]);
          const newChar = {
            characterName: character.name,
            characterId: characterID,
            expiresOn: character.exp,
          };
          characterArray.push(newChar);
          //setCharacterArray((prev) => [...prev, newChar])
        }
      });
      if (characterArray.length) {
        this.setState({ authStatus: "loggedIn" });
        this.setState({ characterList: characterArray });
      }
    }
    /*
    setInterval(() => {
      //Cleanup of characters with invalid refreshtokens that have failed to fetch new data once called.
      const invalidTokens = readInvalid();
      if (invalidTokens.length && characterList !== null) {
        let newCharList = characterList;
        let newCharacterArray: CharacterInfo[] = this.state.characterList;
        invalidTokens.forEach((item: string) => {
          const characterToRemove = jwt_decode<Token>(item);
          const characterIDToRemove = parseInt(characterToRemove.sub.split(":")[2]);
          window.localStorage.removeItem("accesstoken-" + characterIDToRemove);
          window.localStorage.removeItem("refreshtoken-" + characterIDToRemove);
          newCharList = newCharList.replace(characterIDToRemove.toString(), "");
          newCharacterArray = newCharacterArray.filter((el) => el.characterId !== characterIDToRemove);
        });
        window.sessionStorage.removeItem("invalidToken");
        this.setState({ characterList: newCharacterArray });
        if (!newCharacterArray.length) this.setState({ authStatus: "notLoggedIn" });
      }
    }, 10000);
    */
    if (!Office.context.requirements.isSetSupported("CustomFunctionsRuntime", "1.4")) {
      console.log("not supported version");
      console.log(Office.context.platform);
      this.setState({ notsupported: true });
    }
  }
  //Excel customfunctions buttons
  injectAllCharactersFunction = async () => {
    const namespace =
      window.location.host.startsWith("localhost") || window.location.host.startsWith("exceldevstc")
        ? window.location.host.startsWith("localhost")
          ? "=EVEONLINEDEV" /* Dev */
          : "=EVEONLINETEST" /* Test */
        : "=EVEONLINE"; /* Prod */
    try {
      await Excel.run(async (context) => {
        /**
         * Insert your Excel code here
         */
        const range = context.workbook.getSelectedRange();
        // Read the range address
        range.load("address");
        const pretty = namespace + ".ACTIVE_CHARACTER()";
        range.values = [[pretty]];

        await context.sync();
        //console.log(`The range address was ${range.address}.`);
      });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { title, isOfficeInitialized } = this.props;
    if (!isOfficeInitialized) {
      return (
        <Progress
          title={title}
          logo={require("./../../../assets/logo-filled.png")}
          message="Please sideload your addin to see app body."
        />
      );
    }

    return (
      <div className="ms-welcome">
        <Version>
          <Link href="https://forums.eveonline.com/c/technology-research/eve-excel-add-in" underline>
            v1.8.74
          </Link>
        </Version>
        <ThemeButton>
          <div className="theme-button" onClick={this.toggleTheme}></div>
        </ThemeButton>
        <Header
          logo={"https://web-cdn.eveonline.com/aws/eveonline/sso/eve-logo.svg"}
          title={this.props.title}
          message="Welcome"
        />
        {this.state.apiErrorShow && (
          <MessageBar
            className="is-fixed"
            messageBarType={MessageBarType.warning}
            isMultiline={true}
            onDismiss={this.errorMessageDismissed}
          >
            {this.state.apiError}
          </MessageBar>
        )}
        {this.state.notsupported === false && (
          <>
            <div className="ms-welcome__action_container">
              <ButtonWrap>
                {this.state.authStatus === "loggedIn" && (
                  <>
                    <ActionButton title="Log out of all characters and clear cache.">
                      <LoginButton onClick={this.logout}>
                        <EveLogo />
                        <span>LOG OUT</span>
                      </LoginButton>
                    </ActionButton>
                  </>
                )}
              </ButtonWrap>
            </div>
            <CharacterWrap>
              {this.state.authStatus === "loggedIn" && (
                <Button style={{ marginLeft: 5 }} onClick={this.injectAllCharactersFunction}>
                  Character list
                </Button>
              )}
              {this.state.characterList.map((item, index) => {
                return (
                  <CharacterBox
                    key={index}
                    name={item.characterName}
                    id={item.characterId}
                    clearSingleTokenAndCharacter={() =>
                      this.clearSingleTokenAndCharacter(item.characterId ? item.characterId : 1)
                    }
                  />
                );
              })}
            </CharacterWrap>
            <ClickableDiv onClick={this.login}>
              <CharacterBox name="Add a character" id={1} clearSingleTokenAndCharacter={() => {}} />
            </ClickableDiv>
            {this.state.errorMessage && (
              <CenteredDiv>
                <Text align="center" font="monospace" block={true} className="redbold">
                  Error
                </Text>
                <Text align="center" font="monospace" block={true} className="red">
                  {this.state.errorMessage}
                </Text>
              </CenteredDiv>
            )}
            <FaqList />
            <Text align="center" block={true}>
              <Link href="https://eve-excel-functions.vercel.app/">
                <Button className="website-button" icon={<Link32Regular />}>
                  Functions reference website
                </Button>
              </Link>
            </Text>
            <Divider>Functions</Divider>
            <CommandsList />
          </>
        )}
        {this.state.notsupported === true && (
          <CenteredDiv>
            <p style={{ textAlign: "center", padding: "0.5em" }}>
              This version of Excel does not meet the requirements for rich data types. If you get this error on 365
              Excel please ensure the correct license is selected (Account - Switch License).
            </p>
            <a
              style={{ textAlign: "center", display: "block" }}
              href="https://support.eveonline.com/hc/en-us/articles/8165207770524-EVE-Online-Excel-Add-in"
            >
              Excel Add-in support article
            </a>
          </CenteredDiv>
        )}
      </div>
    );
  }
}
